export class Serial {
    public id: number;
    public itemId: number;
    public serialNumber: string;
    public serialDate: Date|undefined;
    public createBy: number|undefined;
    public createDate: Date|undefined;
    public updatedBy: number|undefined;
    public updatedDate: Date|undefined;
    public deletedBy: number|undefined;
    public deletedDate: Date|undefined;
    public isActive:boolean;

    [key: string]: string | number | Date | boolean | undefined;

    constructor(other?: Partial<Serial>) {
        this.id = other?.id || 0;
        this.itemId = other?.itemId || 0;
        this.serialNumber = other?.serialNumber || "";
        this.serialDate = other?.serialDate || undefined;
        this.createBy = other?.createBy || undefined;
        this.createDate = other?.createDate || undefined;
        this.updatedBy = other?.updatedBy || undefined;
        this.updatedDate = other?.updatedDate || undefined;
        this.deletedBy = other?.deletedBy || undefined;
        this.deletedDate = other?.deletedDate || undefined;
        this.isActive = other?.isActive || true;
    }
}